import { ReviewBriefButton } from './ReviewBriefButton';
import { SubmitMultiStepBriefButton } from './SubmitBriefButton';

export function ContinueButton({ showReview }: { showReview: boolean }) {
    return showReview ? <ReviewBriefButton /> : <SubmitMultiStepBriefButton isEditMode={false} />;
}
